/* eslint-disable react/prop-types */
import * as React from 'react';

export const ArrowLeft = props => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.2049 4.20438C11.6442 3.76529 12.3564 3.76512 12.7957 4.20438C13.2347 4.64366 13.2347 5.35592 12.7957 5.7952L6.59061 11.9988L12.7957 18.2039C13.2349 18.6431 13.2345 19.3553 12.7957 19.7947C12.3564 20.2341 11.6442 20.2341 11.2049 19.7947L4.20438 12.7957C3.76512 12.3564 3.76529 11.6442 4.20438 11.2049L11.2049 4.20438Z"
      fill={props.color || '#64748B'}
    />
    <path
      d="M18.9995 10.875C19.6208 10.875 20.1245 11.3787 20.1245 12C20.1245 12.6213 19.6208 13.125 18.9995 13.125H5C4.37868 13.125 3.875 12.6213 3.875 12C3.875 11.3787 4.37868 10.875 5 10.875H18.9995Z"
      fill={props.color || '#64748B'}
    />
  </svg>
);
